import { render } from "./IconSvg.vue?vue&type=template&id=4d243067"
import script from "./IconSvg.vue?vue&type=script&lang=js"
export * from "./IconSvg.vue?vue&type=script&lang=js"

import "./IconSvg.vue?vue&type=style&index=0&id=4d243067&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/home_website/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__